import React, {useEffect, useRef, useState} from 'react';
import Box from '@mui/material/Box';
import MaterialReactTable, { MRT_FullScreenToggleButton, MRT_GlobalFilterTextField, MRT_ShowHideColumnsButton, MRT_TableInstance, MRT_ToggleDensePaddingButton, MRT_ToggleFiltersButton, MRT_ToggleGlobalFilterButton, MRT_ToolbarDropZone, 
 MRT_ToolbarAlertBanner 
} from 'material-react-table';
//import type { MRT_Row } from 'material-react-table';
//Import Material React Table Translations
import { MRT_Localization_FA } from 'material-react-table/locales/fa';
import { Button, IconButton, Tooltip } from '@mui/material';
//import RefreshIcon from '@mui/icons-material/Refresh';
import FilterIcon from '@mui/icons-material/FilterAlt';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import ExportIcon from '@mui/icons-material/FilePresent';
import { CSVLink } from "react-csv";
import { IMrt_grid_prop_Client } from './IMrt_grid_prop';
import type { MRT_ColumnFiltersState, MRT_DensityState, MRT_RowSelectionState, MRT_SortingState, MRT_VisibilityState} from "material-react-table";
import MrtRefreshCounter from './MrtRefreshCounter';

function getWindowSize() {
  const {innerWidth, innerHeight} = window;
  return {innerWidth, innerHeight};
}

const MrtGridclient = ({
    stickyOffset,
    disableStickyFooter,
    
    disableFilters,
    disableColumnResizing,
    disableColumnFilterModes,
    disableStickyHeader,
    disableSorting,
    disableFullScreenToggle,
    disablePagination,
    disableTableFooter,
    disableHiding,
    disableTopToolbar,
    disableBottomToolbar,
    disableColumnActions,
    disableGlobalFilter,

    enableDensityToggle,
    enableGrouping,
    enablePinning,
    enableColumnOrdering,
    enableColumnDragging,
    enableClickToCopy,
    enableRowSelection,
    enableSelectAll,
    enableExcelExport,
    enableMultiRowSelection,
    enableDarkMode,
    enableRefreshCounter,
    
    headerColor,
    initialState_showColumnFilters,
    initialState_paginationSize,
    initialState_columnPinning_left,
    initialState_columnPinning_right,
    initialState_columnVisibility,
    initialState_columnSorting,
    getRowId,
    isLoading,
    columns,
    data,
    onNeedData,
    onCustomFilterClick,
    onRowSelection,
    rowActions,
    topToolbarCustomActions,
    name,
    disableAutoRenderRowActions,
    rowActionsRenderer,
    getRowStyle,
    renderDetailPanel,
    enableExpandAll,
    // muiExpandButtonProps,
    // muiDetailPanelProps
    }: IMrt_grid_prop_Client ) => {

      const isFirstRender = useRef(true);

    
    const [windowSize, setWindowSize] = React.useState(getWindowSize());
    /*const setRefetch = async() =>  {
      await onNeedData();
    }*/
    
    useEffect(() => {
      function handleWindowResize() {
        setWindowSize(getWindowSize());
      }

      window.addEventListener('resize', handleWindowResize);

      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }, []);

    const craeteExcelData = (dt: any) => {
      return dt.map((m:any) => {
        columns.forEach((col:any) => {
          if(col.accessorFn){
            let obj:any = {};
            obj[`${col.id}`] = col.accessorFn(m);
            m = {...m, ...obj}
          }
        });
        return m;
      });
    }

    const craeteExcelHeader = () => {
      return columns.map((c:any) =>  {
        return { label: c.header, key: c.id }
      });
    }
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

    useEffect(() => {
      let t = tableInstanceRef.current?.getSelectedRowModel();
      
      if(onRowSelection ){
        if (t?.rows && t?.rows.length > 0){
          enableMultiRowSelection 
              ? onRowSelection(t?.rows.map((m: any)=> m.original)) 
              : onRowSelection(t?.rows[0].original);
        }
        else{
          onRowSelection(undefined);
        }
      }
    }, [rowSelection]);

    const tableInstanceRef = React.useRef<MRT_TableInstance<any>>(null); //ts
    
    var actionWidth = 6;
    if(rowActions?.length??0 > 0 ){
      rowActions?.map(m => actionWidth += (((m.title??'123456').length) * 8 + 25) );
    }



    const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
      [],
    );
    const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
      {},
    );
    const [density, setDensity] = useState<MRT_DensityState>('compact');
    const [globalFilter, setGlobalFilter] = useState<string | undefined>(
      undefined,
    );
    const [showGlobalFilter, setShowGlobalFilter] = useState(false);
    const [showColumnFilters, setShowColumnFilters] = useState(false);
    const [sorting, setSorting] = useState<MRT_SortingState>([]);

    function getUniqName(params: string) {
      return  window.location.pathname  + '/' + name + '/' + params;
    }
      //load state from local storage 
    useEffect(() => {
      const columnFilters = localStorage.getItem(getUniqName('mrt_columnFilters'));
      const columnVisibility = localStorage.getItem(
        getUniqName('mrt_columnVisibility'),
      );
      const density = localStorage.getItem(getUniqName('mrt_density'));
      const globalFilter = localStorage.getItem(getUniqName('mrt_globalFilter'));
      const showGlobalFilter = localStorage.getItem(
        getUniqName('mrt_showGlobalFilter'),
      );
      const showColumnFilters = localStorage.getItem(
        getUniqName('mrt_showColumnFilters'),
      );
      const sorting = localStorage.getItem(getUniqName('mrt_sorting'));

      if (columnFilters) {
        setColumnFilters(JSON.parse(columnFilters));
      }
      if (columnVisibility) {
        setColumnVisibility(JSON.parse(columnVisibility));
      }
      if (density) {
        setDensity(JSON.parse(density));
      }
      if (globalFilter) {
        setGlobalFilter(JSON.parse(globalFilter) || undefined);
      }
      if (showGlobalFilter) {
        setShowGlobalFilter(JSON.parse(showGlobalFilter));
      }
      if (showColumnFilters) {
        setShowColumnFilters(JSON.parse(showColumnFilters));
      }
      if (sorting) {
        setSorting(JSON.parse(sorting));
      }
      isFirstRender.current = false;
    }, []);

  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_columnFilters'),
      JSON.stringify(columnFilters),
    );
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_columnVisibility'),
      JSON.stringify(columnVisibility),
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(getUniqName('mrt_density'), JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_globalFilter'),
      JSON.stringify(globalFilter ?? ''),
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_showGlobalFilter'),
      JSON.stringify(showGlobalFilter),
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      getUniqName('mrt_showColumnFilters'),
      JSON.stringify(showColumnFilters),
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(getUniqName('mrt_sorting'), JSON.stringify(sorting));
  }, [sorting]);
  
  const resetState = () => {
    localStorage.removeItem(getUniqName('mrt_columnFilters'));
    localStorage.removeItem(getUniqName('mrt_columnVisibility'));
    localStorage.removeItem(getUniqName('mrt_density'));
    localStorage.removeItem(getUniqName('mrt_globalFilter'));
    localStorage.removeItem(getUniqName('mrt_showGlobalFilter'));
    localStorage.removeItem(getUniqName('mrt_showColumnFilters'));
    localStorage.removeItem(getUniqName('mrt_sorting'));
    window.location.reload();
  };

  return (
    <MaterialReactTable
        tableInstanceRef={tableInstanceRef}
        enableColumnActions={!disableColumnActions}
        enableFilters={!disableFilters}
        enableHiding={!disableHiding}
        enableTableFooter={!disableTableFooter}
        enableClickToCopy={enableClickToCopy}
        enablePagination={!disablePagination}
        enableFullScreenToggle={!disableFullScreenToggle}
        enableSorting={!disableSorting}
        enableColumnFilterModes={!disableColumnFilterModes}
        enableColumnOrdering={enableColumnOrdering}
        enablePinning={enablePinning}
        enableRowActions={rowActions && rowActions.length > 0}
        enableRowSelection={enableRowSelection}
        enableDensityToggle={enableDensityToggle?true:false}
        enableColumnResizing={!disableColumnResizing}
        enableSelectAll={enableSelectAll}
        enableMultiRowSelection={enableMultiRowSelection}
        enableGlobalFilter={!disableGlobalFilter}
        enableStickyHeader={!disableStickyHeader}
        enableTopToolbar={!disableTopToolbar}
        enableBottomToolbar={!disableBottomToolbar}
        enableStickyFooter={!disableStickyFooter}
        //positionToolbarAlertBanner="bottom"
        muiTableContainerProps={!disableStickyFooter ? 
          { sx: { maxHeight: (windowSize.innerHeight - (stickyOffset || 0)) + 'px' } } : undefined}
        enableGrouping={enableGrouping}
        enableColumnDragging={enableColumnDragging}
        groupedColumnMode = "reorder"
        // state={{ isLoading, rowSelection }}
        state={{
          isLoading, rowSelection,
          columnFilters,
          columnVisibility,
          density,
          globalFilter,
          showColumnFilters,
          showGlobalFilter,
          sorting,
        }}
        onRowSelectionChange={setRowSelection}
        initialState={{ 
          showColumnFilters: initialState_showColumnFilters, 
          showGlobalFilter: false , 
          columnPinning: { left: initialState_columnPinning_left , right: initialState_columnPinning_right},
          pagination: { pageSize: initialState_paginationSize || 50, pageIndex: 0 }, 
          density: 'compact',
          columnVisibility: initialState_columnVisibility ? Object.assign({},...initialState_columnVisibility) : {},
          sorting:initialState_columnSorting || []
        }}
        localization={MRT_Localization_FA}
        columns={columns} 
        data={data} 
        renderDetailPanel={renderDetailPanel}
        enableExpandAll={enableExpandAll}
        // muiExpandButtonProps={muiExpandButtonProps}
        // muiDetailPanelProps={muiDetailPanelProps}
        getRowId={getRowId}
        renderRowActions={({ cell,row,table }) => (
          <React.Fragment>
         {!disableAutoRenderRowActions===true && <Box key={row.index} sx={{ display: 'flex', flexWrap: 'nowrap', gap: '0.6rem', p: '2px' }}>
            {rowActions?.map((m, idx) => 
              <React.Fragment key={idx + "frg" + row.index} >{(!m.tooltip || !m.icon) &&
                  <Button disabled={m.disabled} style={{display: m.hidden ? "none" : "block"}} key={idx + "Btn" + row.index} color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} startIcon={m.icon} onClick={() => m.handleClick(row.original)}>
                    {m.title} 
                  </Button>
               }</React.Fragment>
            )}
            {rowActions?.map((m, idx) => <React.Fragment key={idx + "withIcon" + row.index} >{(m.tooltip && m.icon) &&
              <Tooltip key={idx + "withTooltip" +row.index} arrow title={m.tooltip}>
                  <IconButton onClick={() => m.handleClick(row.original)} >
                    {m.icon}
                  </IconButton>
              </Tooltip> }</React.Fragment>
            )} 
          </Box>}
          {disableAutoRenderRowActions===true && rowActionsRenderer(cell,row,table)}
          </React.Fragment>
        )}
        displayColumnDefOptions={{
          'mrt-row-actions': {
            header: 'عمليات', // Change header text
            size: actionWidth, //make actions column wider
          },
        }}
        renderTopToolbar={({ table }) => (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '0rem', padding: '4px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'start', padding: '2px'}}>
                {/* <Tooltip arrow title=" بازخواني اطلاعات">
                  <IconButton onClick={async() => await onNeedData()}>
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>  */}
                {onCustomFilterClick && <Tooltip arrow title="شرايط گزارش">
                  <IconButton onClick={() => onCustomFilterClick()} style={{marginLeft: 7}}>
                    <FilterIcon />
                  </IconButton>
                </Tooltip>}
                {topToolbarCustomActions?.map((m,i) =>   
                <React.Fragment key={i}> 
                  {(!m.tooltip || !m.icon) &&
                    <Button style={{marginLeft:'2px'}} color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} onClick={() => m.handleClick(table)}>
                      {m.icon && m.icon} {m.title} 
                    </Button>}
                </React.Fragment>)}
                {topToolbarCustomActions?.map((m,i) =>   
                <React.Fragment key={i}> 
                  {(m.tooltip && m.icon) &&
                    <Tooltip arrow title={m.tooltip}>
                      <IconButton onClick={() => m.handleClick(table)} >
                        {m.icon}
                      </IconButton>
                    </Tooltip>}
                  </React.Fragment>
                )}
              </Box>
              <Box sx={{ display: 'flex', flex: 'auto'}}>
                <MRT_ToolbarDropZone table={table}/>
                <MRT_ToolbarAlertBanner table={table} stackAlertBanner={false}/>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'end'}}>
                <MrtRefreshCounter title="بازخواني" refreshFn={onNeedData} enable={enableRefreshCounter ? 'true' : 'false'}/>
                {enableExcelExport && <Tooltip arrow title="خروجي اكسل">
                  <IconButton>
                  <CSVLink data={craeteExcelData(data)} style={{color:'gray'}} headers={craeteExcelHeader()}>
                      <ExportIcon />
                    </CSVLink>            
                  </IconButton>
                </Tooltip>}
                {!disableFilters && !disableGlobalFilter && <MRT_GlobalFilterTextField table={table} />}
                {!disableFilters && !disableGlobalFilter && <MRT_ToggleGlobalFilterButton table={table} />}
                {!disableFilters && <MRT_ToggleFiltersButton table={table} />}
                <MRT_ShowHideColumnsButton table={table} />
                {enableDensityToggle && <MRT_ToggleDensePaddingButton table={table} />}
                <Tooltip arrow title="بازنشاني تنظيمات جدول">
                  <IconButton onClick={resetState} >
                    <RestoreFromTrashIcon />
                  </IconButton>
                </Tooltip>
                {!disableFullScreenToggle && <MRT_FullScreenToggleButton table={table} />}
            </Box>
          </Box>
        )}
        renderTopToolbarCustomActions={({ table }) => (
          <Box sx={{ display: 'flex', gap: '1rem', p: '4px' }}>
            {/* <Tooltip arrow title=" بازخواني اطلاعات">
              <IconButton onClick={async() => await onNeedData()}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>  */}
            <MrtRefreshCounter title="بازخواني" refreshFn={onNeedData} enable={enableRefreshCounter ? 'true' : 'false'}/>
            {onCustomFilterClick && <Tooltip arrow title="شرايط گزارش">
              <IconButton onClick={() => onCustomFilterClick()} >
                <FilterIcon />
              </IconButton>
            </Tooltip>}
            {enableExcelExport && <Tooltip arrow title="خروجي اكسل">
              <IconButton>
              <CSVLink data={craeteExcelData(data)} style={{color:'gray'}} headers={craeteExcelHeader()}>
                  <ExportIcon />
                </CSVLink>            
              </IconButton>
            </Tooltip>}
            <Tooltip arrow title="بازنشاني تنظيمات جدول">
              <IconButton onClick={resetState} >
                <RestoreFromTrashIcon />
              </IconButton>
            </Tooltip>
            {topToolbarCustomActions?.map((m,i) =>   
              <React.Fragment key={i}> 
                {(!m.tooltip || !m.icon) &&
                  <Button disabled={m.disabled} color={m.color || 'primary'} variant={m.variant || 'contained'} size={m.size || 'small'} onClick={() => m.handleClick(table)}>
                    {m.icon && m.icon} {m.title} 
                  </Button>}
              </React.Fragment>)}
            {topToolbarCustomActions?.map((m,i) =>   
            <React.Fragment key={i}> 
              {(m.tooltip && m.icon) &&
                <Tooltip arrow title={m.tooltip}>
                  <IconButton disabled={m.disabled} onClick={() => m.handleClick(table)} >
                    {m.icon}
                  </IconButton>
                </Tooltip>}
              </React.Fragment>
            )}
          </Box>
        )}
        muiTableHeadProps={{
          sx: {
            '& tr, tr th': {
              backgroundColor: headerColor ?? (enableDarkMode ? '#003636' : '#e5f6fd'), //'#f0f0f0',//'#e5f6fd',//
              fontSize: '13px',
              padding: '0.6rem'
            },
          }                          
        }}
        muiTableBodyProps = {enableRowSelection
          ?{
            sx: {
              '& tr td': {
                fontSize: '13px'
              },
            }         
          }
          :{
          sx: {
            '& tr td': {
              fontSize: '13px'
            },
            '& tr:nth-of-type(odd)': {
              backgroundColor: enableDarkMode ? '#1a1a1a' : '#fafdff'
            },
          }         
        }}
        muiTableBodyRowProps={({ row }) => ({
          //add onClick to row to select upon clicking anywhere in the row
          onClick: (event: any) => {
          console.log(event.target.localName)
            if (event.target.localName != 'button' && event.target.localName != 'text' &&  event.target.localName != 'path' &&  event.target.localName != 'svg') row.toggleSelected();
          },
          style:{backgroundColor:getRowStyle?getRowStyle(row):''},
          sx: { cursor: 'pointer' },
        })}

        onColumnFiltersChange={setColumnFilters}
        onColumnVisibilityChange={setColumnVisibility}
        onDensityChange={setDensity}
        onGlobalFilterChange={setGlobalFilter}
        onShowColumnFiltersChange={setShowColumnFilters}
        onShowGlobalFilterChange={setShowGlobalFilter}
        onSortingChange={setSorting}
    />
  );
}

export default MrtGridclient;